import { VIDEO_EXTENSIONS } from '../config';

/**
 * Given an extension, return true if the extension is of a video. Don't include
 * the dot prefix (e.g. 'mp4' rather than '.mp4').
 */
export function isVideoByExt(extension: string): boolean {
  return VIDEO_EXTENSIONS.includes(extension);
}
